import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Axios from 'axios'
import { toast } from 'react-toastify'
import { useAuth } from '../../Utils/Auth'
import zLogo from '../../Assets/Images/Zefyron_logo_white.png'
import './AdminSidebar.css'

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import ApartmentIcon from '@mui/icons-material/Apartment'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import BarChartIcon from '@mui/icons-material/BarChart'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt'
import LogoutIcon from '@mui/icons-material/Logout'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'

function AdminSidebar () {
  const location = useLocation()
  const navigate = useNavigate()
  const { setcallSuperAdmin } = useAuth()
  const [collapsed, setCollapsed] = useState(false)

  const isActive = path =>
    location.pathname === path || location.pathname.startsWith(path + '/')

  useEffect(() => {
    document.body.classList.toggle('main-sidebar-collapsed', collapsed)
    return () => document.body.classList.remove('main-sidebar-collapsed')
  }, [collapsed])

  const logout = async () => {
    await Axios('/api/admin/logout')
      .then(() => {
        toast.success('Logged Out')
        navigate('/')
      })
      .catch(() => toast.error('Some Error'))
  }

  return (
    <aside className={`admin-sidebar${collapsed ? ' collapsed' : ''}`}>
      {/* Logo + toggle */}
      <div className='sidebar-logo-section'>
        {!collapsed && (
          <Link to='/zr-admin-dashboard'>
            <img src={zLogo} alt='Zefyron' />
          </Link>
        )}
        <button
          className='sidebar-toggle-btn'
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </button>
      </div>

      <nav className='sidebar-nav'>
        <Link
          to='/zr-admin-dashboard'
          className={`sidebar-nav-item ${
            isActive('/zr-admin-dashboard') ? 'active' : ''
          }`}
          title={collapsed ? 'Dashboard' : undefined}
        >
          <DashboardOutlinedIcon style={{ fontSize: 24 }} />
          <span className='sidebar-nav-label'>Dashboard</span>
        </Link>
        <button
          className={`sidebar-nav-item ${
            isActive('/admin/sales') ? 'active' : ''
          }`}
          onClick={() => {
            setcallSuperAdmin(true)
            navigate('/admin/sales')
          }}
          title={collapsed ? 'Sales CRM' : undefined}
        >
          <PointOfSaleIcon style={{ fontSize: 24 }} />
          <span className='sidebar-nav-label'>Sales CRM</span>
        </button>
        <Link
          to='/admin/user-activity'
          className={`sidebar-nav-item ${
            isActive('/admin/user-activity') ? 'active' : ''
          }`}
          title={collapsed ? 'Check User Activity' : undefined}
        >
          <BarChartIcon style={{ fontSize: 24 }} />
          <span className='sidebar-nav-label'>Check User Activity</span>
        </Link>

        <Link
          to='/admin/all-corporates'
          className={`sidebar-nav-item ${
            isActive('/admin/all-corporates') ? 'active' : ''
          }`}
          title={collapsed ? 'All Corporates' : undefined}
        >
          <ApartmentIcon style={{ fontSize: 24 }} />
          <span className='sidebar-nav-label'>All Corporates</span>
        </Link>

        <Link
          to='/admin/all-funds'
          className={`sidebar-nav-item ${
            isActive('/admin/all-funds') ? 'active' : ''
          }`}
          title={collapsed ? 'All Fund Companies' : undefined}
        >
          <AccountTreeOutlinedIcon style={{ fontSize: 24 }} />
          <span className='sidebar-nav-label'>All Fund Companies</span>
        </Link>

        <hr className='sidebar-divider' />

        {!collapsed && (
          <div className='sidebar-section-label'>New Requests</div>
        )}

        <Link
          to='/admin/verify-founder'
          className={`sidebar-sub-item ${
            isActive('/admin/verify-founder') ? 'active' : ''
          }`}
          title={collapsed ? 'Startup Requests' : undefined}
        >
          <RocketLaunchOutlinedIcon style={{ fontSize: 18 }} />
          <span className='sidebar-sub-label'>Startup Requests</span>
        </Link>
        <Link
          to='/admin/verify-investor'
          className={`sidebar-sub-item ${
            isActive('/admin/verify-investor') ? 'active' : ''
          }`}
          title={collapsed ? 'Investor Requests' : undefined}
        >
          <AttachMoneyIcon style={{ fontSize: 18 }} />
          <span className='sidebar-sub-label'>Investor Requests</span>
        </Link>
        <Link
          to='/admin/all-investors'
          className={`sidebar-sub-item ${
            isActive('/admin/all-investors') ? 'active' : ''
          }`}
          title={collapsed ? 'All Investors' : undefined}
        >
          <GroupsOutlinedIcon style={{ fontSize: 18 }} />
          <span className='sidebar-sub-label'>All Investors</span>
        </Link>
        <Link
          to='/admin/verify-fundcompany'
          className={`sidebar-sub-item ${
            isActive('/admin/verify-fundcompany') ? 'active' : ''
          }`}
          title={collapsed ? 'Fund Requests' : undefined}
        >
          <AccountBalanceOutlinedIcon style={{ fontSize: 18 }} />
          <span className='sidebar-sub-label'>Fund Requests</span>
        </Link>
        <Link
          to='/admin/verify-corporate'
          className={`sidebar-sub-item ${
            isActive('/admin/verify-corporate') ? 'active' : ''
          }`}
          title={collapsed ? 'Corporate Requests' : undefined}
        >
          <CorporateFareIcon style={{ fontSize: 18 }} />
          <span className='sidebar-sub-label'>Corporate Requests</span>
        </Link>

        <hr className='sidebar-divider' />

        <Link
          to='/admin/notification'
          className={`sidebar-nav-item ${
            isActive('/admin/notification') ? 'active' : ''
          }`}
          title={collapsed ? 'Admin Notification' : undefined}
        >
          <NotificationsNoneIcon style={{ fontSize: 24 }} />
          <span className='sidebar-nav-label'>Admin Notification</span>
        </Link>

        <Link
          to='/admin/platformupdates'
          className={`sidebar-nav-item ${
            isActive('/admin/platformupdates') ? 'active' : ''
          }`}
          title={collapsed ? 'Platform Updates' : undefined}
        >
          <SystemUpdateAltIcon style={{ fontSize: 24 }} />
          <span className='sidebar-nav-label'>Platform Updates</span>
        </Link>
      </nav>

      {/* Logout */}
      <div className='sidebar-footer'>
        <button
          className='sidebar-logout-btn'
          onClick={logout}
          title={collapsed ? 'Logout' : undefined}
        >
          <LogoutIcon style={{ fontSize: 24 }} />
          <span className='sidebar-nav-label'>Logout</span>
        </button>
      </div>
    </aside>
  )
}

export function AdminLayout ({ children }) {
  return (
    <>
      <AdminSidebar />
      <div className='admin-layout-content'>{children}</div>
    </>
  )
}

export default AdminSidebar
